import { Component, Prop, Vue } from 'vue-property-decorator';
import CardEmpty from './empty/empty.vue';

/**
 * card
 */
@Component({ name: 'Card', components: { CardEmpty } })
export default class extends Vue {
    /**
     * 标题
     */
    @Prop({ required: true }) public title!: string;
}
